import { useState, useEffect } from "react";
import axios from "axios";
import SideNavbaBarDashboard from "../SideNavaBarDashboard/SideNavbaBarDashboard";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { CiMenuBurger } from "react-icons/ci";
const Address = () => {
  const [addresses, setAddresses] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentAddressId, setCurrentAddressId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    customerId:"",
    address: "",
    district: "",
    state: "",
    pincode: "",
  });

  // Fetch mobile number from localStorage (assuming token is already decoded and mobile number is stored)
  const mobile = localStorage.getItem("phoneNumber"); // Assuming mobile is stored in localStorage after login
  const customerId = localStorage.getItem("phoneNumber");
  useEffect(() => {
    if (customerId) {
   
      axios
      
        .get(`/api/addresses/${customerId}`)
        .then((response) => {
          setAddresses(response.data);
        })
        .catch((error) => {
          console.error("Error fetching addresses:", error);
        });
    }
  }, [customerId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const handleAddAddress = () => {
  //   if (editMode) {
  //     // Update existing address
      
    

  //     axios
  //       .put(`/api/addresses/${currentAddressId}`, formData)
  //       .then((response) => {
  //         const updatedAddresses = addresses.map((address) =>
  //           address._id === currentAddressId ? response.data : address
  //         );
  //         setAddresses(updatedAddresses);
  //         setFormData({
  //           name: "",
  //           mobile: "",
  //           address: "",
  //           district: "",
  //           state: "",
  //           pincode: "",
  //         });
  //         setEditMode(false);
  //         setIsAdding(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error updating address:", error);
  //       });
  //   } else {
  //     // Add new address
  //     formData.append("customerId", customerId);
  //     formData.append("mobile", mobile);
      
  //     // Add other form data fields
  //     formData.append("name", formData.name);
  //     formData.append("address", formData.address);
  //     formData.append("district", formData.district);
  //     formData.append("state", formData.state);
  //     formData.append("pincode", formData.pincode);
  //     axios
  //       .post(`/api/addresses`, formData)
  //       .then((response) => {
  //         setAddresses([...addresses, response.data]);
  //         setFormData({
  //           name: "",
  //           mobile: "",
  //           address: "",
  //           district: "",
  //           state: "",
  //           pincode: "",
  //         });
  //         setIsAdding(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error adding address:", error);
  //       });
  //   }
  // };

  const handleAddAddress = () => {
    if (!editMode) {
      const payload = {
        customerId,
        mobile: formData.mobile,
        name: formData.name,
        address: formData.address,
        district: formData.district,
        state: formData.state,
        pincode: formData.pincode,
      };
      console.log("Payload being sent:", payload); // Debugging output
      axios
        .post(`/api/addresses`, payload)
        .then((response) => {
          setAddresses([...addresses, response.data]);
          setFormData({
            name: "",
            mobile: "",
            address: "",
            district: "",
            state: "",
            pincode: "",
          });
          setIsAdding(false);
        })
        .catch((error) => {
          console.error("Error adding address:", error.response?.data || error);
        });
    }else{
           axios
        .put(`/api/addresses/${currentAddressId}`, formData)
        .then((response) => {
          const updatedAddresses = addresses.map((address) =>
            address._id === currentAddressId ? response.data : address
          );
          setAddresses(updatedAddresses);
          setFormData({
            name: "",
            mobile: "",
            address: "",
            district: "",
            state: "",
            pincode: "",
          });
          setEditMode(false);
          setIsAdding(false);
        })
        .catch((error) => {
          console.error("Error updating address:", error);
        });
  
    }
  };
  

  const handleEditAddress = (addressId) => {
    setEditMode(true);
    setCurrentAddressId(addressId);
    const addressToEdit = addresses.find((address) => address._id === addressId);
    setFormData({
      name: addressToEdit.name,
      mobile: addressToEdit.mobile,
      address: addressToEdit.address,
      district: addressToEdit.district,
      state: addressToEdit.state,
      pincode: addressToEdit.pincode,
    });
    setIsAdding(true);
  };

  // const handleDeleteAddress = (addressId) => {
  //   axios.delete(`/api/addresses/${addressId}`)

  //     .then(() => {
  //       setAddresses(addresses.filter((address) => address._id !== addressId));
  //     })
  //     .catch((error) => {
  //       console.error("Error deleting address:", error);
  //     });
  // };

  const handleDeleteAddress = (addressId) => {
    axios.delete(`/api/addresses/${addressId}`)
      .then(() => {
        // Directly update the state after deletion
        setAddresses(prevAddresses => prevAddresses.filter((address) => address._id !== addressId));
      })
      .catch((error) => {
        console.error("Error deleting address:", error);
      });
  };
  
  const handleCancel = () => {
    setIsAdding(false);
    setEditMode(false);
    setFormData({
      name: "",
      mobile: "",
      address: "",
      district: "",
      state: "",
      pincode: "",
    });
  };

  return (
    <>
      <div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>My Address</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>My Address</h6></div>
                        </div>
                    </div>
                </div>
            </div>
      <section className="flat-spacing-11">
        <div className="container">
          <div className="row">
            <SideNavbaBarDashboard />
            
            <div className="col-lg-9">
              <div className="my-account-content account-address">
                {isAdding ? (
                  <div className="text-center widget-inner-address">
                    <div className="title">{editMode ? "Edit address" : "Add a new address"}</div>
                    <form className="show-form-address wd-form-address">
                      <div className="box-field">
                        <div className="tf-field style-1">
                          <input
                            className="tf-field-input tf-input"
                            placeholder=" "
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                          />
                          <label className="tf-field-label fw-4 text_black-2" htmlFor="name">
                            Name
                          </label>
                        </div>
                      </div>
                      <div className="box-field">
                        <div className="tf-field style-1">
                          <input
                            className="tf-field-input tf-input"
                            placeholder=" "
                            type="number"
                            id="mobile"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                          />
                          <label className="tf-field-label fw-4 text_black-2" htmlFor="mobile">
                            Mobile Number
                          </label>
                        </div>
                      </div>
                      <div className="box-field">
                        <div className="tf-field style-1">
                          <input
                            className="tf-field-input tf-input"
                            placeholder=" "
                            type="text"
                            id="address"
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                          />
                          <label className="tf-field-label fw-4 text_black-2" htmlFor="address">
                            Address
                          </label>
                        </div>
                      </div>
                      <div className="box-field">
                        <div className="tf-field style-1">
                          <input
                            className="tf-field-input tf-input"
                            placeholder=" "
                            type="text"
                            id="district"
                            name="district"
                            value={formData.district}
                            onChange={handleInputChange}
                          />
                          <label className="tf-field-label fw-4 text_black-2" htmlFor="district">
                            District
                          </label>
                        </div>
                      </div>
                      <div className="box-field">
                        <div className="tf-field style-1">
                          <input
                            className="tf-field-input tf-input"
                            placeholder=" "
                            type="text"
                            id="state"
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                          />
                          <label className="tf-field-label fw-4 text_black-2" htmlFor="state">
                            State
                          </label>
                        </div>
                      </div>
                      <div className="box-field">
                        <div className="tf-field style-1">
                          <input
                            className="tf-field-input tf-input"
                            placeholder=" "
                            type="number"
                            id="pincode"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleInputChange}
                          />
                          <label className="tf-field-label fw-4 text_black-2" htmlFor="pincode">
                            Pincode
                          </label>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="tf-btn btn-fill animate-hover-btn btn-address"
                        onClick={handleAddAddress}
                      >
                        {editMode ? "Update Address" : "Add Address"}
                      </button>
                      <button
                        type="button"
                        className="tf-btn btn-outline animate-hover-btn btn-address"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                ) : (
                  <>
                    <button
                      className="tf-btn btn-fill animate-hover-btn btn-address mb_20"
                      onClick={() => setIsAdding(true)}
                    >
                      Add a new address
                    </button>
                    <div className="list-account-address">
                      {addresses.map((address) => (
                        <div key={address._id} className="account-address-item">
                          <h6 className="mb_20">Address</h6>
                          <p>{address.name}</p>
                          <p>{address.mobile}</p>
                          <p>{address.address}</p>
                          <p>{address.district}</p>
                          <p>{address.state}</p>
                          <p>{address.pincode}</p>
                          <div className="d-flex gap-10 justify-content-center">
                            <button
                              className="tf-btn btn-fill animate-hover-btn btn-edit-address"
                              onClick={() => handleEditAddress(address._id)}
                            >
                              Edit
                            </button>
                            <button
                              className="tf-btn btn-outline animate-hover-btn justify-content-center"
                              onClick={() => handleDeleteAddress(address._id)}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="btn-sidebar-account">
                <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                    <CiMenuBurger />
                </button>
            </div>

    </>
  );
};

export default Address;
